import { action } from 'mobx'

import BaseListStore, { IBaseListAddOptions } from 'stores/base/BaseListStore'

import getEnumId from 'utils/getEnumId'

import Enum, { IEnumCreatePayload } from './Enum'

class EnumStore extends BaseListStore<Enum, IEnumCreatePayload> {
  constructor() {
    super(Enum)
  }

  @action
  add(
    enumerable: Omit<IEnumCreatePayload, 'id'>,
    options: IBaseListAddOptions = {}
  ): Enum {
    return super.add(
      {
        id: getEnumId(enumerable.name),
        ...enumerable,
      },
      options
    )
  }

  getByName = (name: string): Enum | null => {
    // Since the enum's ID is its name, searching by name can be made fast.
    // DO NOT use the above information outside this class. We do not want to leak implementation details outside.
    return this.get(name)
  }
}

export default new EnumStore()
